/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  VestaDexTrader,
  VestaDexTraderInterface,
} from "../VestaDexTrader";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "BadReturnValueFromERC20OnTransfer",
    type: "error",
  },
  {
    inputs: [],
    name: "CannotBeNativeChainToken",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyRequest",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ErrorTransferETH",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minimumAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "receivedAmount",
        type: "uint256",
      },
    ],
    name: "FailedToReceiveExactAmountOut",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidContract",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPermission",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTraderSelector",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "NoContract",
    type: "error",
  },
  {
    inputs: [],
    name: "NonReentrancy",
    type: "error",
  },
  {
    inputs: [],
    name: "NumberIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "RoutingNotFound",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_paramValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_msgValue",
        type: "uint256",
      },
    ],
    name: "SanitizeMsgValueFailed",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "identifier",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokenTransferGenericFailure",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "returnedCallData",
        type: "bytes",
      },
    ],
    name: "TraderFailed",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "maximumAmountIn",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "requestedAmountIn",
        type: "uint256",
      },
    ],
    name: "TraderFailedMaxAmountInExceeded",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes1",
        name: "newPermission",
        type: "bytes1",
      },
    ],
    name: "PermissionChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tokenIn",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
    ],
    name: "RouteUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "executor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[2]",
        name: "tokenInOut",
        type: "address[2]",
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "amountInOut",
        type: "uint256[2]",
      },
    ],
    name: "SwapExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes16",
        name: "selector",
        type: "bytes16",
      },
    ],
    name: "TraderRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "TraderRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "_firstTokenIn",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_firstAmountIn",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bytes16",
            name: "traderSelector",
            type: "bytes16",
          },
          {
            internalType: "address[2]",
            name: "tokenInOut",
            type: "address[2]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct ManualExchange[]",
        name: "_requests",
        type: "tuple[]",
      },
    ],
    name: "exchange",
    outputs: [
      {
        internalType: "uint256[]",
        name: "swapDatas_",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bytes16",
            name: "traderSelector",
            type: "bytes16",
          },
          {
            internalType: "address[2]",
            name: "tokenInOut",
            type: "address[2]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct ManualExchange[]",
        name: "_requests",
        type: "tuple[]",
      },
    ],
    name: "getAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn_",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bytes16",
            name: "traderSelector",
            type: "bytes16",
          },
          {
            internalType: "address[2]",
            name: "tokenInOut",
            type: "address[2]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct ManualExchange[]",
        name: "_requests",
        type: "tuple[]",
      },
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
    ],
    name: "getPermissionLevel",
    outputs: [
      {
        internalType: "bytes1",
        name: "",
        type: "bytes1",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes16",
        name: "_selector",
        type: "bytes16",
      },
    ],
    name: "getTraderAddressWithSelector",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        internalType: "bytes1",
        name: "accessLevel",
        type: "bytes1",
      },
    ],
    name: "hasPermissionLevel",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "isRegisteredTrader",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes16",
        name: "_selector",
        type: "bytes16",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "registerTrader",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes16",
        name: "_selector",
        type: "bytes16",
      },
      {
        internalType: "address",
        name: "_trader",
        type: "address",
      },
    ],
    name: "removeTrader",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address",
      },
      {
        internalType: "bytes1",
        name: "_permission",
        type: "bytes1",
      },
    ],
    name: "setPermission",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VestaDexTraderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VestaDexTraderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VestaDexTrader__factory extends ContractFactory {
  constructor(...args: VestaDexTraderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<VestaDexTrader> {
    return super.deploy(overrides || {}) as Promise<VestaDexTrader>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VestaDexTrader {
    return super.attach(address) as VestaDexTrader;
  }
  override connect(signer: Signer): VestaDexTrader__factory {
    return super.connect(signer) as VestaDexTrader__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VestaDexTraderInterface {
    return new utils.Interface(_abi) as VestaDexTraderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VestaDexTrader {
    return new Contract(address, _abi, signerOrProvider) as VestaDexTrader;
  }
}
